import "./OurSolutions.module.css";
import Header from "@/reusable_sections/Header";
import Hydroizolacja from "./sections/Hydroizolacja";
import Services from "./sections/Services";
import Process from "./sections/Process";
import Footer from "@/reusable_sections/Footer";
export default function OurSolutionsPage() {
  return <div>
      <Header />
      <Hydroizolacja />
      <Services />
      <Process />
      <Footer />
    </div>;
}